const PRODUCT_URL_KEY = "3dcreator-product-key";

const toUrlSafeBase64 = (value) =>
  btoa(unescape(encodeURIComponent(value)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");

const fromUrlSafeBase64 = (value) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;
  const padded = padding ? normalized + "=".repeat(4 - padding) : normalized;
  return decodeURIComponent(escape(atob(padded)));
};

const xorCipher = (value, key = PRODUCT_URL_KEY) =>
  value
    .split("")
    .map((char, index) =>
      String.fromCharCode(
        char.charCodeAt(0) ^ key.charCodeAt(index % key.length),
      ),
    )
    .join("");

export const slugifyProductPart = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 50);

export const getPrimaryVariant = (product) => {
  if (!product?.variants?.length) return null;
  return product.variants.find((variant) => variant?.is_delete !== "yes") || product.variants[0];
};

export const encodeProductToken = (payload) => {
  const serialized = JSON.stringify(payload);
  return toUrlSafeBase64(xorCipher(serialized));
};

export const decodeProductToken = (token) => {
  try {
    const decoded = fromUrlSafeBase64(token);
    const json = xorCipher(decoded);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

// Legacy links contain a slug followed by an encoded payload. Since URL-safe
// base64 may itself contain hyphens, taking only the text after the last
// hyphen is not reliable. Try each possible slug boundary instead.
export const decodeProductTokenFromPath = (rawToken = "") => {
  const directPayload = decodeProductToken(rawToken);

  if (directPayload?.productId) return directPayload;

  for (
    let index = rawToken.indexOf("-");
    index !== -1;
    index = rawToken.indexOf("-", index + 1)
  ) {
    const payload = decodeProductToken(rawToken.slice(index + 1));

    if (payload?.productId) return payload;
  }

  return null;
};

export const buildProductDetailsPath = (product) => {
  if (!product?._id) return "/products";

  const slug = slugifyProductPart(product.name) || "product";

  // The Mongo product id is already unique and URL-safe. Keeping variant data
  // out of the path makes one stable canonical URL per product.
  return `/p/${slug}-${product._id}`;
};

export const extractProductIdFromToken = (rawToken = "") => {
  if (!rawToken) return "";

  const idMatch = rawToken.match(/(?:^|-)([a-f\d]{24})$/i);
  if (idMatch) return idMatch[1];

  const decoded = decodeProductTokenFromPath(rawToken);

  return decoded?.productId || "";
};
